import { Phone, Mail } from "lucide-react";
import { COMPANY, NAV_LINKS } from "./data";

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-black">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={COMPANY.logo}
                alt="Chowat Security"
                className="h-32 md:h-40 w-auto drop-shadow-[0_0_36px_rgba(220,38,38,0.55)]"
              />
              <span className="font-display text-3xl md:text-4xl tracking-tight">
                Chowat<span className="text-[color:var(--primary-text)]">.</span>
              </span>
            </div>
            <p
              data-testid="footer-slogan"
              className="mt-5 font-editorial italic text-white/85 text-lg leading-snug max-w-sm"
            >
              “{COMPANY.slogan}”
            </p>
            <p className="mt-4 text-secondary max-w-sm leading-relaxed">
              {COMPANY.name} — 100% Indigenous-owned security, grounded in cultural
              values, professional training and an uncompromising commitment to safety.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.24em] text-secondary mb-5">Navigate</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => go(l.href)}
                    data-testid={`footer-nav-${l.href.replace("#", "")}`}
                    className="text-white/80 hover:text-[color:var(--primary-text)] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.24em] text-secondary mb-5">Contact</div>
            <a href={COMPANY.phoneHref} className="flex items-center gap-3 text-white/80 hover:text-white transition-colors">
              <Phone size={16} className="text-[color:var(--primary-text)]" /> {COMPANY.phone}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="mt-3 flex items-center gap-3 text-white/80 hover:text-white transition-colors break-all">
              <Mail size={16} className="text-[color:var(--primary-text)]" /> {COMPANY.email}
            </a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-secondary">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span className="uppercase tracking-widest text-xs">Indigenous-Owned · Licensed · Insured</span>
        </div>
      </div>
    </footer>
  );
};
